"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeVersion = void 0;
class IkeVersion {
    /**
     * Convert a semver string eg '2.3.0' into a single number
     *
     * Useful when wanting to do comparisions of semver eg is '2.13.3' newer '2.9.1'
     *
     * This uses a shift of 256 per sem ver chunk, so the max version for anyone version is 256,
     *
     * 0.0.1 -> 1
     * 0.0.50 -> 50
     * 0.1.0 -> 256
     * 0.2.0 -> 512
     * 0.2.10 -> 522
     *
     * @param semver SemVer version number
     * @return Value as a number
     */
    static toNumber(semver) {
        const parts = semver.split('.');
        if (parts.length > 3) {
            throw new Error('Invalid semver `2.3.0`');
        }
        while (parts.length !== 3) {
            parts.push('0');
        }
        let current = 0;
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            const shift = (parts.length - 1 - i) * 8;
            current = current + (parseInt(part, 10) << shift); // tslint:disable-line
        }
        return current;
    }
    /**
     * Reverse a semver number conversion
     *
     * @See IkeVersion.toNumber
     */
    static fromNumber(i) {
        const output = [];
        while (i > 0) {
            output.unshift(i % 256);
            i = i >> 8; // tslint:disable-line
        }
        if (output.length > 3) {
            throw new Error('Invalid semver');
        }
        while (output.length < 3) {
            output.unshift('0');
        }
        return output.join('.');
    }
    /**
     * Attempt to parse a var as a semver
     * @param version
     */
    static parse(version) {
        if (typeof version === 'number') {
            return version;
        }
        if (version.indexOf('.') > -1) {
            return IkeVersion.toNumber(version);
        }
        return parseInt(version, 10);
    }
}
exports.IkeVersion = IkeVersion;
//# sourceMappingURL=index.js.map